import React from 'react'

import './Color.css'


const Color = ({ color, style = {}, size = "normal" }) => (
  <div className={`color-show color-show-${size}`} style={{ ...style, backgroundColor: color }}></div>
)
export default Color